import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import 'overlayscrollbars/overlayscrollbars.css';
import { App } from './App';

registerSW({ immediate: true });

// Немедленная активация нового Service Worker при обновлении
navigator.serviceWorker?.ready.then((reg) => {
  if (reg.waiting) {
    reg.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
});

// StrictMode отключён — без двойного рендера в dev
createRoot(document.getElementById('root')!).render(<App />);
